export const stateOrgControlConstants = {
	CLEAR  : 'CLEAR_STATE_ORG_CONTROL',
	Create : {
		REQUEST : 'CREATE_STATE_ORG_CONTROL_REQUEST',
		SUCCESS : 'CREATE_STATE_ORG_CONTROL_SUCCESS',
		FAILURE : 'CREATE_STATE_ORG_CONTROL_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_STATE_ORG_CONTROL_REQUEST',
		SUCCESS : 'UPDATE_STATE_ORG_CONTROL_SUCCESS',
		FAILURE : 'UPDATE_STATE_ORG_CONTROL_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_STATE_ORG_CONTROL_REQUEST',
		SUCCESS : 'DELETE_STATE_ORG_CONTROL_SUCCESS',
		FAILURE : 'DELETE_STATE_ORG_CONTROL_FAILURE'
	},
	GetPaged: {
		REQUEST : 'GET_PAGED_STATE_ORG_CONTROL_REQUEST',
		SUCCESS : 'GET_PAGED_STATE_ORG_CONTROL_SUCCESS',
		FAILURE : 'GET_PAGED_STATE_ORG_CONTROL_FAILURE'
	}
}